import Categories from 'Modules/contacard/faq/categories/routes';
import Questions from 'Modules/contacard/faq/questions/routes';
import { buildSubModuleRoute } from 'Arch/helpers/RouterHelper';

export default [
  buildSubModuleRoute({
    moduleId: 'contacard',
    name: 'faq',
    path: 'faq/',
    subModuleTitle: 'FAQ',
    children: [...Categories, ...Questions],
  }),
];
